import React from 'react'
import { Field, useField } from "formik"
import './FormikField.scss'

interface IFormikField {
    name: string
    readonly: boolean
    placeholder: string
    className?: string
    tabIndex?: number
}

const FormikField: React.FC<IFormikField> = (props) => {
    const { name, readonly, placeholder, className, tabIndex } = props

    const [field, meta, helpers] = useField(name)

    const styles: Array<string | undefined> = ["input"]
    if (field.value) {
        styles.push("input--filled")
    } else {
        styles.push("input-not-filled")
    }
    if (meta.touched && meta.error) {
        styles.push("input--required")
    }
    styles.push(className)

    return (
        <label htmlFor="" className={"field"}>
            <Field
                name={name}
                placeholder={placeholder}
                readOnly={readonly}
                className={styles.filter(Boolean).join(" ")}
                tabIndex={tabIndex}
            />
        </label>
    )
}

export default FormikField